





















































import {Component, Prop} from "vue-property-decorator"
import AbpBase from "@/lib/abpbase"
import {GetDicsByCode} from "@/api/systemBasic"
import {GetPropaganda, SavePatEducationEvaluate} from "@/api/propaganda"


@Component({
	components: {}
})
export default class Warehouse extends AbpBase {
	@Prop({type: Boolean, default: false}) value: Boolean
	@Prop() data: any

	model:any = {
		patientId: this.data.patientId,
		resourceId: this.data.resourceId,
		eduObject: '患者本人',
		eduType: '口头讲解',
		eduEvaluate: '完全掌握',
		eduPlace: '床边',
		remarks: '',
		status: true
	}
	async created() {
		console.log(this.data)
	}
	async save() {
		let res = await SavePatEducationEvaluate(this.model)
		this.$emit('save-success')
	}

	cancel(){
		this.$emit('input', false)
	}
	rules={}
	visibleChange(value: boolean) {
		if (!value) {
			this.$emit('input', value);
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/education/educationPlan/parts/evaluate.vue